<ng-container *ngIf="finalGuideBanners.length > 1">
    <div class="guide-banners">
        <div *ngFor="let banner of finalGuideBanners" class="guide-banner" (click)="bannerClicked(banner.desktopEvent)">
            <a [href]="banner.articleUrl" target="_blank">
                <img [src]="banner.bannerPath" [alt]="banner.name">
            </a>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="finalGuideBanners.length === 1">
    <div class="guide-banner-first-fly" (click)="bannerClicked(finalGuideBanners[0].desktopEvent)">
        <a [href]="finalGuideBanners[0].articleUrl" target="_blank">
            <img [src]="finalGuideBanners[0].bannerPath" [alt]="finalGuideBanners[0].name">
        </a>
    </div>
</ng-container>
